import * as TYPES from '../types';

const initialState = {
    vacanciesList: [],
};

export function VacanciesReducer(state = initialState, action) {
    const preState = { ...state };
    const { type, payload } = action;
    switch (type) {
        case TYPES.GET_ALL_VACANCIES_SUCCESS:
            return {
                ...preState,
                vacanciesList: payload,
            };

        default:
            return state;
    }
}